import { Grid, Hidden } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { ContentSpacer } from '../../global/components/layout/generic-content-spacer';
import { MainContent } from '../../global/components/layout/main-content-container';
import { PageContainer } from '../../global/components/layout/page-container';
import { PageHeader } from '../../global/components/layout/page-header';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';
import { searchPageStyles } from '../../global/constants/theme/styles/pages/search/search-page-layout';
import { sortTableStyles } from '../../global/constants/theme/styles/tables/generic-sort-table';
import { useBasePath } from '../../global/hooks/useBasePath';
import useWindowDimensions from '../../global/hooks/useWindowSize';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { InstitutionState } from '../../pages/arc/features/institutions/institution-model';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { BackendPagination } from '../components/backend-pagination';
import { BackendSearchList } from '../components/backend-search-list';
import { CheckBoxFilter } from '../components/checkbox-filter';
import { DateTypeFilter } from '../components/date-type-filter';
import { FilterActionButtons } from '../components/filter-actions-buttons';
import { FilterPills } from '../components/filter-pills';
import { BackendSearchState, FilterTypes, SearchApp, SearchAppContext } from '../models/search-models';
import { resetSearchByApp } from '../slices/backend-search-slice';
import { updateChangeLogList } from './change-log-requests';
import { EmployeeChangeLogItemView } from './employee-change-log-item';
import { EmployeeChangeLogLabels } from './employee-change-log-labels';



export function ChangeLogSearch() {

	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
	const institutionState = useSelector<TcsmStates, InstitutionState>(state => state.institutionState);
	const institutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionSearch}`);
	const { state } = useLocation<any>();
	const windowDimension = useWindowDimensions();
	const desktopScreenSize = windowDimension?.width >= 1024;
	const [expand, setExpand] = useState(desktopScreenSize);
	const [firstExpand, setFirstExpand] = useState(true);
	const buttonClasses = buttonStyles();
	const pageClasses = searchPageStyles();
	const tableClasses = sortTableStyles();

	const dispatch = useDispatch();


	useEffect(() => {
		return function cleanUp() {
			dispatch(resetSearchByApp(SearchApp.CHANGE_LOG));
		};
	}, []);

	if (!institutionState?.institutionClientNumber) {
		return (
			<Redirect to=
				{
					{
						pathname: institutionSelect,
						state,
					}
				}
			/>);
	}

	const setExpandAction = () => {
		setExpand(!expand);
		setFirstExpand(!expand);
	};


	return (
		<SearchAppContext.Provider value={SearchApp.CHANGE_LOG}>
			<PageContainer>
				<MainContent fullWidth>
					<PageHeader
						headerText={searchSettings?.employeeChangeLogTitle}
						description={searchSettings?.employeeChangeLogDescription}
					/>
					<Grid container alignItems='flex-start'>
						<Grid className={pageClasses.searchFilters} container item md={12} lg={3}>
							<Grid className='filters-header' item sm={12} container justifyContent='space-between' alignItems='baseline'>
								<h2>{searchSettings?.filterSectionTitle}</h2>
								<button className={buttonClasses.linkButton} type='button' onClick={setExpandAction} ><strong>{expand ? searchSettings?.collapseFilterText : searchSettings?.showAllFilterText}</strong></button>
							</Grid>
							<FilterPills />
							<div className='filters-tablet-columns'>
								<div className='filters-tablet-columns-item'>
									<DateTypeFilter filterTitle={searchSettings?.employeeChangeLogDateTypeLabel} expand={firstExpand} />
									<CheckBoxFilter
										filterType={FilterTypes.employee}
										filterTitle={searchSettings?.employeeFilterLabel}
										filterHelperText={searchSettings?.employeeFilterLabel}
										expand={expand}
									/>
								</div>
								<div className='filters-tablet-columns-item'>
									<CheckBoxFilter
										filterType={FilterTypes.submittedBy}
										filterTitle={searchSettings?.submittedByFilterLabel}
										filterHelperText={searchSettings?.submittedByHelperText}
										expand={expand}
									/>
									<CheckBoxFilter
										filterType={FilterTypes.eventType}
										filterTitle={searchSettings?.eventTypeFilterLabel}
										filterHelperText={searchSettings?.eventTypeFilterHelperText}
										expand={expand}
									/>
									<FilterActionButtons />
								</div>

							</div>
						</Grid>
						<Grid item xs>
							<ContentSpacer>
								<Grid item sm={12} container justifyContent='space-between' alignItems='baseline' spacing={1}>
									<Grid item>
										<p>{searchSettings?.filterOptionHelperText}</p>
									</Grid>
								</Grid>
							</ContentSpacer>
							<div className={tableClasses.sortTable}>
								<Hidden xsDown>
									<EmployeeChangeLogLabels />
								</Hidden>
								<div className='sort-table-content'>
									<BackendSearchList
										updateList={(searchState: BackendSearchState) => updateChangeLogList(searchState, searchSettings?.eventTypeMapping, dispatch, institutionState?.institutionClientNumber, SearchApp.CHANGE_LOG)}
										renderItem={(item) => <EmployeeChangeLogItemView key={`${item?.event_id}-${item.submittedDate}`} item={item} settings={searchSettings} />}
										emptyResultMessage={searchSettings?.employeeChangeLogEmptyResult}
									/>
									<BackendPagination />
								</div>
							</div>
						</Grid>
					</Grid>
				</MainContent>
			</PageContainer>
		</SearchAppContext.Provider>
	);
}

export default ChangeLogSearch;